import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons/faExclamationCircle";
import ModalControls from "../../../common/ModalControls";
import { useNavigate, useLocation } from "react-router-dom";
import { defaultFormState } from "../../../../../defaults/Forms";
import {zusTypeDefault} from "../../../../../defaults/Items";

import {
  onSaveAndClose,
  compareData,
  restoreFormData,
  onItemsListDeleteButtonClick,
  onCloseDetails, setForegroundColor
} from "../../../../../helpers/ComponentHelper";

import AppComponentCardHeader from "../../../common/AppComponentCardHeader";
import LoadingDataDiv from "../../../common/LoadingDataDiv";
import DeleteWarningModal from "../../../common/DeleteWarningModal";
import SettingsEntityModal from "../../../common/SettingsEntityModal";
import TextInput from "../../../../elements/TextInput";
import TextArea from "../../../../elements/TextArea";
import useCrud from "../../../../../hooks/useCrud";
import { Table } from "../../../../table/Table";

import {faInfoCircle} from "@fortawesome/free-solid-svg-icons";
import Toggler from "../../../../elements/Toggler";
import {HexColorPicker} from "react-colorful";
import NumberInput from "../../../../elements/NumberInput";
import {faQuestionCircle} from "@fortawesome/free-solid-svg-icons/faQuestionCircle";


const ZusBasis = () => {

  const dataUrl = "/zus-basis";
  const relatedItemsUrl = null; // if no need to check it, initialize with null and remove RelatedItemsList from details modal
  const defaultItem = zusTypeDefault;
  const itemName = "Podstawa ZUS";
  const itemNames = "Podstawy ZUS";
  const navigate = useNavigate();
  const location = useLocation();
  const {createItem, updateItem, deleteItem, getItems, getRelatedChildrenByParentId} = useCrud(dataUrl);

  const [loading, setLoading] = useState(true);
  const [allowDelete, setAllowDelete] = useState(null);
  const [currentFormState, setCurrentFormState] = useState(defaultFormState);
  const [itemsList, setItems] = useState([]);
  const [currentItem, setCurrentItem] = useState(defaultItem);
  const [backupItem, setBackupItem] = useState(defaultItem);
  const [itemChanged, setItemChanged] = useState(false);
  const [updateConflict, setUpdateConflict] = useState(false);


  // elements related to the item
  const columns = [
    {label: "Id", accessor: "id", sortable: true, searchable: false},
    {label: "Nazwa", accessor: "name", sortable: true, searchable: true},
    {label: "Skrócona nazwa", accessor: "shortName", sortable: true, searchable: true},
    {label: "Opis", accessor: "description", sortable: true, searchable: true},
    {label: "Edycja", accessor: "editBtn", sortable: false, searchable: false},
    {label: "Usuń", accessor: "deleteBtn", sortable: false, searchable: false},
  ];


  const state = {
    itemsList, setItems,
    currentItem, setCurrentItem,
    currentFormState, setCurrentFormState,
    defaultItem, backupItem, setBackupItem, itemChanged, setItemChanged,
    setAllowDelete,
    setRelatedItems: null
  }


  const onDelete = async () => {
    const response = await deleteItem(`${dataUrl}/${currentItem.id}`, currentItem.id, state);
    if (response === 401 || response === 403) {
      navigate('/login', {state: {from: location}, replace: true});
    }
  }


  const onSaveItemClick = async (e) => {
    e.preventDefault();
    if (!currentItem.name || !currentItem.shortName) {
      if (!currentItem.name) {
        let nameInput = document.getElementById("name");
        nameInput.classList.add("form-input-invalid");
        nameInput.placeholder = `ten element jest wymagany`;
      }

      if (!currentItem.shortName) {
        let shortNameInput = document.getElementById("shortName");
        shortNameInput.classList.add("form-input-invalid");
        shortNameInput.placeholder = `ten element jest wymagany`;
      }
      return;
    }

    let response;
    const item = {
      id: currentItem.id,
      shortName: currentItem.shortName,
      name: currentItem.name,
      description: currentItem.description,
      color: currentItem.color,
      retirement: currentItem.retirement,
      disability: currentItem.disability,
      sickness: currentItem.sickness,
      accident: currentItem.accident,
      health: currentItem.health,
      labourFund: currentItem.labourFund,
      solidarity: currentItem.solidarity,
      guaranteedEmployeeBenefits: currentItem.guaranteedEmployeeBenefits


    };
    if (currentFormState.formAddingDataMode) {
      response = await createItem(dataUrl, item, state);
    } else {
      response = await updateItem(`${dataUrl}/${item.id}`, item, state);
    }

    if (response.status === 401 || response.status === 403) {
      navigate('/login', {state: {from: location}, replace: true});
    } else if (response.status === 409) {
      setUpdateConflict(true);

    } else {
      response && onSaveAndClose({state});
    }
  }

  const checkRelatedItems = async (id) => {
    //const data = await getRelatedChildrenByParentId(`${ relatedItemsUrl }/${ id }`, id, setEventsList);
    //data.length === 0 ? setAllowDelete(true) : setAllowDelete(false);
    setAllowDelete(true);
  }


  const onClose = () => {
    setUpdateConflict(false);
    onCloseDetails({state});
  };


  useEffect(() => {
    if (updateConflict) setUpdateConflict(false);
    compareData(currentFormState, setCurrentFormState, currentItem, backupItem);
  }, [itemChanged])


  useEffect(() => {
    if (allowDelete !== null) {
      onItemsListDeleteButtonClick(currentFormState, setCurrentFormState, itemName, allowDelete, currentItem.name);
    }
  }, [allowDelete])


  useEffect(() => {
    const getData = async () => {
      const response = await getItems(dataUrl);
      if (response.status === 200) {

        setLoading(false);
        setItems(response.data);

      } else if (response.status === 401 || response.status === 403) {
        navigate('/login', {state: {from: location}, replace: true})
      } else {
        alert("Nie udało się pobrać danych.");
      }
    };
    getData();
  }, [])


  const getCompleteItem = async (id) => {
    const response = await getItems(`${dataUrl}/${id}`);
    if (response.status === 200) {
      return response.data;
    } else if (response.status === 401 || response.status === 403) {
      navigate('/login', {state: {from: location}, replace: true})
    } else {
      alert("Nie udało się pobrać danych.");
    }
  }


  const addDataButtonProps = {
    setCurrentItem,
    setBackupItem,
    defaultItem,
    currentFormState,
    setCurrentFormState,
    formDescription: `Tu możesz dodać nowy element.`,
    formHeader: `Nowy element`,
    buttonTitle: ` Dodaj nowy typ podstawy ZUS`
  }


  let dataSectionContent;
  if (loading) {
    dataSectionContent = <LoadingDataDiv/>
  } else if (itemsList.length > 0) {
    dataSectionContent =
      <Table
        rows={itemsList}
        columns={columns}
        state={state}
        checkRelatedItems={checkRelatedItems}
        formHeader={`Edycja ${itemName}`}
        relatedItemsUrl={relatedItemsUrl}
        getCompleteItem={getCompleteItem}
      />
  } else {
    dataSectionContent =
      <div className={"warn_info"}><FontAwesomeIcon
        className={"warning-icon div-visible"} icon={faExclamationCircle}/>&nbsp;&nbsp;&nbsp;NIE ZNALEZIONO ŻADNYCH DANYCH</div>
  }
  return (
    <div id="layoutSidenav_content" className="settings-entity-page">
      <AppComponentCardHeader title="Podstawy ZUS" buttonProps={addDataButtonProps}/>

      <div className="container-fluid px-4 py-3">
        <div className={itemsList.length > 0 ? "card shadow p-1 mb-5 bg-white rounded-2" : "card shadow mb-5 bg-transparent rounded-2"}>
          {dataSectionContent}
        </div>
      </div>

      <SettingsEntityModal
        show={currentFormState.showForm}
        onClose={onClose}
        title={currentFormState.formAddingDataMode ? "Nowa pozycja: Podstawa ZUS" : `Edycja: ${currentItem.name || "Podstawa ZUS"}`}
        adding={currentFormState.formAddingDataMode}
        introText="Podstawa ZUS określa, które składki mają zastosowanie dla danego sposobu rozliczania pracownika."
        onRestore={() => { setUpdateConflict(false); restoreFormData({state}); }}
        onDelete={onDelete}
        onSubmit={onSaveItemClick}
        state={state}
        size="xl"
      >
        <form id="add-zusType-form" name="add-zusType-form" className="settings-form-content-card">
                            <div className="row form-group mb-2">
                              <div className="col-md-3 form-label">
                                <label htmlFor="name" className="">Nazwa *</label>
                              </div>
                              <div className="col-md-9">
                                <TextInput propertyName="name" required={true} state={ state }/>
                              </div>
                            </div>
                            <div className="row form-group mb-2">
                              <div className="col-md-3 form-label">
                                <label htmlFor="shortName" className="">Skrót *</label>
                              </div>
                              <div className="col-md-1">
                                <TextInput propertyName="shortName" maxlen="10" required={true} state={state}/>
                              </div>
                            </div>
                            <div className="row form-group mb-2">
                              <div className="col-md-3 form-label">
                                <label htmlFor="description" className="">Opis</label>
                              </div>
                              <div className="col-md-9">
                                <TextArea propertyName="description" required={false} rows="2" state={state}/>
                              </div>
                            </div>


                            <div className="row form-group mb-2">
                              <div className="col-md-3 form-label">
                                <label htmlFor="retirement" className="">Składka emerytalna</label>
                              </div>
                              <div className="col-md-1">
                                <Toggler propertyName="retirement" state={state} />
                              </div>
                            </div>

                            <div className="row form-group mb-2">
                              <div className="col-md-3 form-label">
                                <label htmlFor="disability" className="">Składka rentowa</label>
                              </div>
                              <div className="col-md-1">
                                <Toggler propertyName="disability" state={state} />
                              </div>
                            </div>

                            <div className="row form-group mb-2">
                              <div className="col-md-3 form-label">
                                <label htmlFor="sickness" className="">Składka chorobowa</label>
                              </div>
                              <div className="col-md-1">
                                <Toggler propertyName="sickness" state={state} />
                              </div>
                            </div>

                            <div className="row form-group mb-2">
                              <div className="col-md-3 form-label">
                                <label htmlFor="accident" className="">Składka wypadkowa</label>
                              </div>
                              <div className="col-md-1">
                                <Toggler propertyName="accident" state={state} />
                              </div>
                            </div>

                            <div className="row form-group mb-2">
                              <div className="col-md-3 form-label">
                                <label htmlFor="health" className="">Składka zdrowotna</label>
                              </div>
                              <div className="col-md-1">
                                <Toggler propertyName="health" state={state} />
                              </div>
                            </div>

                            <div className="row form-group mb-2">
                              <div className="col-md-3 form-label">
                                <label htmlFor="labourFund" className="">Fundusz pracy</label>
                              </div>
                              <div className="col-md-1">
                                <Toggler propertyName="labourFund" state={state} />
                              </div>
                            </div>


                            <div className="row form-group mb-2">
                              <div className="col-md-3 form-label">
                                <label htmlFor="solidarity" className="">Fundusz Solidarnościowy</label>
                              </div>
                              <div className="col-md-1">
                                <Toggler propertyName="solidarity" state={state} />
                              </div>
                            </div>


                            <div className="row form-group mb-2">
                              <div className="col-md-3 form-label">
                                <label htmlFor="guaranteedEmployeeBenefits" className="">Fundusz Gwarantowanych Świadczeń Pracowniczych</label>
                              </div>
                              <div className="col-md-1">
                                <Toggler propertyName="guaranteedEmployeeBenefits" state={state} />
                              </div>
                            </div>

                            <p id="conflict_notification" className={updateConflict ? "err_info" : "offscreen"}>
                              <FontAwesomeIcon icon={faInfoCircle}/>&nbsp;
                              Nie można dodać ani zmienić tego elementu, ponieważ istnieje już wpis o tej nazwie i/lub skrócie
                            </p>
                          </form>
      </SettingsEntityModal>

      <DeleteWarningModal state={state} onDelete={onDelete} deleteItemName={itemName}/>
    </div>
  );
}

export default ZusBasis;
